import { createContext, useContext } from 'react';
import { noop } from '@synergy/utils';

interface FilterContextData {
    filter: URLSearchParams;
    updateFilter: (filter: URLSearchParams) => void;
}

export const FilterContext = createContext<FilterContextData>({
    filter: new URLSearchParams(),
    updateFilter: noop,
});
export const useFilter = (): FilterContextData => useContext(FilterContext);
